
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import Events from "./components/Projects";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import Aboutus from './components/aboutus';
import Schedule from './components/schedule';
import Reach from './components/reach';
import { useEffect } from 'react';

import Combos from './components/combos';



function App() {
  useEffect(() => {
    const detectDevTools = setInterval(() => {
      let before = new Date().getTime();
      debugger; // This pauses the code when DevTools is open
      let after = new Date().getTime();

      if (after - before > 100) {
        alert("suspicious activity Detected! Redirecting...");
        window.location.href = "about:blank"; // Redirects to a blank page
      }
    }, 1000);

    return () => clearInterval(detectDevTools); // Clean up interval on unmount
  }, []);
  useEffect(() => {
    // Disable right-click
    document.addEventListener("contextmenu", (event) => event.preventDefault());

    // Disable certain key combinations
    document.addEventListener("keydown", (event) => {
      if (
        event.ctrlKey &&
        (event.key === "U" || event.key === "I" || event.key === "J" || event.key === "S" || event.key === "H" || event.key === "C")
      ) {
        event.preventDefault();
      }
      if (event.key === "F12") {
        event.preventDefault();
      }
    });

    // Cleanup event listeners when component unmounts
    return () => {
      document.removeEventListener("contextmenu", (event) => event.preventDefault());
      document.removeEventListener("keydown", (event) => {
        if (
          event.ctrlKey &&
          (event.key === "U" || event.key === "I" || event.key === "J" || event.key === "S" || event.key === "H" || event.key === "C")
        ) {
          event.preventDefault();
        }
        if (event.key === "F12") {
          event.preventDefault();
        }
      });
    };
  }, []);
  return (
    <>
      <div className="App">
        <NavBar />
        <Banner />
        <Skills />
        <br />
        <Aboutus />
        <Events />
        <Combos />
        <Schedule />
        <Contact />
        <Reach />
        <Footer />


      </div>


    </>
  );
}

export default App;
